/**
 * UTC date-key (`YYYY-MM-DD`) arithmetic shared by the plan activity surfaces.
 * Keys sort lexicographically, so comparisons stay string-based; only the
 * arithmetic goes through Date, always in UTC to avoid local-timezone drift.
 */
export function parseDateKey(dateKey) {
    const [year, month, day] = dateKey.split("-").map(Number);
    return new Date(Date.UTC(year ?? 1970, (month ?? 1) - 1, day ?? 1));
}
export function formatDateKey(date) {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1;
    const day = date.getUTCDate();
    return `${String(year).padStart(4, "0")}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
export function addDaysKey(dateKey, delta) {
    const date = parseDateKey(dateKey);
    date.setUTCDate(date.getUTCDate() + delta);
    return formatDateKey(date);
}
export function daysBetweenKeys(startKey, endKey) {
    const startMs = parseDateKey(startKey).getTime();
    const endMs = parseDateKey(endKey).getTime();
    return Math.round((endMs - startMs) / (24 * 60 * 60 * 1000));
}
/** JS getDay (0=Sun..6=Sat) -> Monday-first index (0=Mon..6=Sun). */
export function mondayIndex(dateKey) {
    return (parseDateKey(dateKey).getUTCDay() + 6) % 7;
}
//# sourceMappingURL=date-key.js.map